module.exports = __webpack_public_path__ + "static/media/no-videos-illustration-min.dfba7a05.webp";